import {
    AgentStateModule,
    Agent,
    AgentInputs,
} from '@/store/modules/agent/types';
import {
    UpdatedTiers,
    UpdatedCallStates,
    UpdatedQueueCalls,
    ChangedAgentState,
    ChangedAgentStatus,
    UpdatedAgentRegistration,
    UpdateLoadingAgent,
    UpdatedLastActivityAtSecs,
    ChangeAgentDoNotDisturb,
} from '@/store/modules/agent/events';
import { AgentStatus, AgentState, Status } from '@/utils/agent';
import { DoNotDisturb as AgentDoNotDisturb } from '@/utils/agent/doNotDisturb';
import Vue from 'vue';

const mutations = {
    addAgentToContainer(state: AgentStateModule, agent: Agent) {
        // if (state.agentsContainer[agent.name]) {
        //     console.warn(`Agent ${agent.name} already exists in the container`);
        //     return;
        // }

        Vue.set(state.agentsContainer, agent.name, agent);
    },
    updateTiers(state: AgentStateModule, { name, tiers }: UpdatedTiers) {
        Vue.set(state.agentsContainer[name], 'tiers', tiers);
    },
    updateCallStates(state: AgentStateModule, { name, callStates }: UpdatedCallStates) {
        const agent = state.agentsContainer[name];
        if (!agent) {
            return;
        }

        const safeCallStates = callStates && typeof callStates === 'object' ? callStates : {};
        Vue.set(agent, 'callStates', new Map(Object.entries(safeCallStates)));
    },
    updateQueueCalls(state: AgentStateModule, { name, queueCalls }: UpdatedQueueCalls) {
        const agent = state.agentsContainer[name];
        if (!agent) {
            return;
        }

        const safeQueueCalls = queueCalls && typeof queueCalls === 'object' ? queueCalls : {};
        Vue.set(agent, 'queueCalls', new Map(Object.entries(safeQueueCalls)));
    },
    changeAgentMetadata(state: AgentStateModule, { name, metadata }: AgentInputs) {
        const agent = state.agentsContainer[name];
        Object.assign(agent.metadata, metadata);
    },
    changeAgentState(
        state: AgentStateModule,
        { name, agentState }: ChangedAgentState,
    ) {
        const agent = state.agentsContainer[name];
        if (agent.state !== AgentState.fromString(agentState)) {
            agent.previousState = agent.state;
            agent.state = AgentState.fromString(agentState);
        }
    },
    changeAgentStatus(
        state: AgentStateModule,
        { name, agentStatus }: ChangedAgentStatus,
    ) {
        const agent = state.agentsContainer[name];
        const newStatus = AgentStatus.fromString(agentStatus);

        if (newStatus === Status.LoggedOut) {
            if (agent.doNotDisturb) {
                agent.doNotDisturb = false;
            }

            if (agent.customStatusMessage !== undefined) {
                Vue.set(agent, 'customStatusMessage', undefined);
            }

            if (agent.dndStartTimeSecs !== undefined) {
                Vue.set(agent, 'dndStartTimeSecs', undefined);
            }
        }

        if (agent.doNotDisturb && newStatus === Status.Available) {
            if (!AgentStatus.isBusy(agent.status)) {
                agent.status = Status.Busy;
            }
            return;
        }

        if (agent.status !== newStatus) {
            agent.status = newStatus;
        }

        if (newStatus === Status.Available) {
            if (agent.customStatusMessage) {
                Vue.set(agent, 'customStatusMessage', undefined);
            }
            if (agent.dndStartTimeSecs) {
                Vue.set(agent, 'dndStartTimeSecs', undefined);
            }
        }
    },
    putAgentInDoNotDisturb(
        state: AgentStateModule,
        params: ChangeAgentDoNotDisturb,
    ) {
        const agent = state.agentsContainer[params.name];
        const isBusy = AgentDoNotDisturb.fromString(params.state);
        if (agent.doNotDisturb !== isBusy) {
            agent.doNotDisturb = isBusy;
        }
        if (isBusy) {
            if (params.status) {
                agent.status = AgentStatus.fromString(params.status);
            } else {
                agent.status = Status.Busy;
            }

            if (params.status) {
                Vue.set(agent, 'customStatusMessage', params.status);
            } else {
                Vue.set(agent, 'customStatusMessage', 'Ocupado');
            }

            // Store the timestamp when DND was activated
            Vue.set(agent, 'dndStartTimeSecs', Math.floor(Date.now() / 1000));
        } else {
            Vue.set(agent, 'customStatusMessage', undefined);
            Vue.set(agent, 'dndStartTimeSecs', undefined);
        }
    },
    updateAgentRegistration(
        state: AgentStateModule,
        { name, connected }: UpdatedAgentRegistration,
    ) {
        const agent = state.agentsContainer[name];
        if (agent.connected !== connected) {
            agent.connected = connected;
        }

        if (!connected) {
            if (agent.doNotDisturb) {
                agent.doNotDisturb = false;
            }

            if (agent.customStatusMessage !== undefined) {
                Vue.set(agent, 'customStatusMessage', undefined);
            }

            if (agent.dndStartTimeSecs !== undefined) {
                Vue.set(agent, 'dndStartTimeSecs', undefined);
            }
        }
    },
    isLoadingAgent(
        state: AgentStateModule,
        { name, isLoading }: UpdateLoadingAgent,
    ) {
        const agent = state.agentsContainer[name];
        if (agent.isLoading !== isLoading) {
            agent.isLoading = isLoading;
        }
    },
    updateLastActivityAtSecs(
        state: AgentStateModule,
        { name, lastActivityAtSecs }: UpdatedLastActivityAtSecs,
    ) {
        Vue.set(state.agentsContainer[name], 'lastActivityAtSecs', lastActivityAtSecs);
    },
};
export default mutations;
